import { differenceInCalendarMonths, differenceInCalendarDays, differenceInHours, } from 'date-fns';
export const TIME_UNITS = {
    DAY: 'DAY',
    HOUR: 'HOUR',
    MONTH: 'MONTH',
};
export const calculateSubscriptionExpiryPeriod = (endDate) => {
    const monthsDiff = differenceInCalendarMonths(new Date(endDate), new Date());
    if (monthsDiff > 1) {
        return {
            unit: TIME_UNITS.MONTH,
            value: monthsDiff,
        };
    }
    else {
        const daysDiff = differenceInCalendarDays(new Date(endDate), new Date());
        return {
            unit: TIME_UNITS.DAY,
            value: daysDiff + 1,
        };
    }
};
export const calculatePromotionExpiryPeriod = (endDate) => {
    const daysDiff = differenceInCalendarDays(new Date(endDate), new Date());
    if (daysDiff > 1) {
        return {
            unit: TIME_UNITS.DAY,
            value: daysDiff,
        };
    }
    else {
        const hoursDiff = differenceInHours(new Date(endDate), new Date());
        return {
            unit: TIME_UNITS.HOUR,
            value: hoursDiff,
        };
    }
};
